module.exports = __webpack_public_path__ + "assets/a577649ef1b0a981257c4df0f6f041f6.png";